import React from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';

export default function CessioneAffittoAzienda({
    setInfoAggiuntive,

    setTipoAttoCessioneAffAzienda,
    TipoAttoCessioneAffAzienda,
    setPrezzoVendita,
    setCanoneAffitto,
    }) {

	return (
		<>  
            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab' >Tipo atto </label>
                    <p>Selezionare una delle opzioni per mostrare i campi richiesti</p>
                    <select onChange={e => setTipoAttoCessioneAffAzienda(e.target.value)} className="select">
                        <option default value="Scegliere">Non so</option>
                        <option value='Cessione d’azienda'>Cessione d'azienda</option>
                        <option value='Affitto d’azienda'>Affitto d'azienda</option>
                    </select>
                </div>
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <div className="field">
                    {(() => {
                        if ( TipoAttoCessioneAffAzienda === 'Cessione d’azienda') {
                            return (
                                <>
                                    <label className='customLab' >Prezzo di vendita</label>
                                    <input type="number" placeholder="500000" name="prezzoVendita" id="prezzoVendita" onChange={e => setPrezzoVendita(e.target.value)} />
                                </>
                            );
                        }
                        if ( TipoAttoCessioneAffAzienda === 'Affitto d’azienda') {
                            return (
                                <>
                                    <label className='customLab' >Canone di affitto</label>
                                    <input type="number" placeholder="1200" name="canoneAffitto" id="canoneAffitto" onChange={e => setCanoneAffitto(e.target.value)} />
                                </>
                            );
                        }
                    })()}
                </div>
            </MDBRow>
            <MDBRow>
                <div className="field">
                    <label className='customLab' for="message">Informazioni aggiuntive</label>
                    <textarea className="message-field" type="textarea" placeholder="Informazioni" name="infoaggiuntive" id="infoaggiuntive" onChange={e => setInfoAggiuntive(e.target.value)} />
                </div>
            </MDBRow>
            </>
	);
}